import React, { useState, useEffect, useRef } from 'react';

import { ReactComponent as CalendarIcon } from '../../assets/icons/calendar-icon-cal.svg';
import { ReactComponent as ClearIcon } from '../../assets/icons/calendar-icon-clear.svg';
import { ReactComponent as SearchIcon } from '../../assets/icons/search-icon.svg';

import DateRangePicker from '@wojtekmaj/react-daterange-picker';
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

// Filtro: testo + date-range
const CallFilterBar = ({ filterParams, onChange }) => {
    const { nome_cognome, dateRange } = filterParams;
    const dateRangeRef = useRef();

    //se si vuole togliere la tastiera virtuale su smartphone in ogni caso..
    // useEffect(() => {
    //     // Imposta readonly su tutti gli input del DateRangePicker
    //     if (dateRangeRef.current) {
    //         const inputs = dateRangeRef.current.querySelectorAll('input');
    //         inputs.forEach(input => {
    //             input.setAttribute('readonly', true);
    //             // Previeni apertura tastiera su mobile
    //             input.addEventListener('focus', (e) => {
    //                 e.target.blur();
    //             });
    //         });
    //     }
    // }, []);

    return (
        <div className="vista-filter-bar">
            <div className="search-wrapper">
                <SearchIcon className="search-icon" />
                <input
                    type="text"
                    className="search"
                    name="nome_cognome"
                    placeholder="Ricerca"
                    value={nome_cognome}
                    onChange={e => onChange({ ...filterParams, nome_cognome: e.target.value })}
                />
            </div>
            <div ref={dateRangeRef}>
                <DateRangePicker
                    className="date-range-picker"
                    onChange={range => onChange({ ...filterParams, dateRange: range })}
                    value={dateRange}
                    clearIcon={<ClearIcon/>}
                    calendarIcon={<CalendarIcon/>}
                    dayPlaceholder='gg'
                    monthPlaceholder='mm'
                    yearPlaceholder='aaaa'
                />
            </div>
        </div>
    );
}
export default CallFilterBar;